import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'
import LoadingButton from 'proposals/components/LoadingButton'
import { useTranslation } from 'react-i18next'

type props = {
  onClose: () => void
  open: boolean
  submitForm: (() => Promise<void>) & (() => Promise<any>)
  isLoadingPropose: boolean
  rfpLang: string
}

const ProposalSubmitDialog: React.FC<props> = ({ onClose, open, submitForm, isLoadingPropose, rfpLang }) => {
  const { t } = useTranslation()

  return (
    <Dialog onClose={onClose} open={open} fullWidth>
      <DialogTitle>{t('send-proposal')}</DialogTitle>
      <DialogContent>
        <Typography color="textSecondary" paragraph>
          {t('send-proposal-text-1')}{' '}
          <Link
            component={RouterLink}
            rel="noopener noreferrer"
            to={`/privacy-policy?lang=${rfpLang}`}
            target="_blank"
            underline="hover"
          >
            {t('privacy-policy-2')}
          </Link>
          .
        </Typography>
        <Typography color="textSecondary">{t('send-proposal-text-3')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button color="grey" onClick={onClose}>
          {t('cancel')}
        </Button>
        <LoadingButton
          sx={{ color: 'common.white', mt: 2, mb: 1 }}
          onClick={submitForm}
          disabled={isLoadingPropose}
          isLoading={isLoadingPropose}
        >
          {t('send')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ProposalSubmitDialog
